import type { FlowDto } from '@/types/dtos/flows/response/flow.dto';

/** Plan/apply responses often omit `liveContext`; keep the running session marker until the server sends an explicit `liveContext` payload. */
export function mergeFlowPreservingLiveContext<T extends FlowDto>(next: T, previous?: FlowDto): T {
  if (!previous?.liveContext?.isRunning) {
    return next;
  }
  if (next.liveContext != null) {
    return next;
  }
  return {
    ...next,
    liveContext: previous.liveContext,
  };
}
